import { bool, number, oneOfType, string } from 'prop-types';
import React, { useMemo } from 'react';
import AiFillStar from '../icons/AiFillStar';
import AiOutlineStar from '../icons/AiOutlineStar';

const MAX_STARS = 5;

export default function MiniProductReviewsBlock({ avgRating, totalReviews, loading }) {
    const stars = useMemo(() => Math.round(avgRating), [avgRating]);
    const starsArr = useMemo(() => ([
        ...new Array(Math.min(stars, MAX_STARS)).fill(1),
        ...new Array(Math.max(0, MAX_STARS - Math.min(stars, MAX_STARS))).fill(0),
    ]), [stars, MAX_STARS]);
    return (<div
        className={'d-flex mt-1 mb-3 reviews-block'}
        style={{ alignItems: 'first baseline' }}>
        {loading === false && (<>
            <span
                className={'me-1'}>
                {starsArr.map((star, idx) => {
                    if (star === 1) {
                        return (<AiFillStar
                            key={idx}
                            size={'15px'}
                            color={'gold'} />);
                    }
                    return (<AiOutlineStar
                        key={idx}
                        size={'15px'} />);
                })}
            </span>
            <span
                style={{ fontSize: '0.7rem' }}>
                {totalReviews === 0 && 'No reviews'}
                {totalReviews === 1 && '1 review'}
                {totalReviews > 1 && (totalReviews + ' reviews')}
            </span>
        </>)}
    </div>);
}

MiniProductReviewsBlock.propTypes = {
    avgRating: oneOfType([number, string]),
    totalReviews: number,
    loading: bool,
};

MiniProductReviewsBlock.defaultProps = {
    avgRating: 0,
    totalReviews: 0,
};